<div class="snackbar" id="snackbar">
  <div [innerHTML]="data.html"></div>
  @if (data.dismiss) {
    <button mat-raised-button (click)="snackBar.dismiss()">Dismiss</button>
  }
</div>
